export enum OutputLayout {
  HORIZONTAL = "Horizontal",
  VERTICAL = "Vertical",
  GRID = "Image Grid",
}

export default OutputLayout;
